import { render } from "./List.vue?vue&type=template&id=7b247472"
import script from "./List.vue?vue&type=script&lang=ts"
export * from "./List.vue?vue&type=script&lang=ts"

import "./List.vue?vue&type=style&index=0&id=7b247472&lang=css"
script.render = render

export default script